import React from "react"
import AdvancedTable from '../../pb_advanced_table/_advanced_table'
import Flex from "../../pb_flex/_flex"
import Badge from "../../pb_badge/_badge"
import Title from "../../pb_title/_title"
import MOCK_DATA from "./advanced_table_mock_data.json"

const AdvancedTableFullWidthCell = (props) => {
  const columnDefinitions = [
    {
      accessor: "year",
      label: "Year",
      cellAccessors: ["quarter", "month", "day"],
      customRenderer: (row, value) => (
        <Flex justify="between">
          <Title size={4}
              text={value}
          />
          <Badge dark
              marginLeft="xxs"
              text={row.original.newEnrollments > 20 ? "High" : "Low"}
              variant="neutral"
          />
        </Flex>
      ),
    },
    {
      accessor: "newEnrollments",
      label: "New Enrollments",
    },
    {
      accessor: "scheduledMeetings",
      label: "Scheduled Meetings",
    },
    {
      accessor: "attendanceRate",
      label: "Attendance Rate",
    },
    {
      accessor: "completedClasses",
      label: "Completed Classes",
    },
    {
      accessor: "classCompletionRate",
      label: "Class Completion Rate",
    },
    {
      accessor: "graduatedStudents",
      label: "Graduated Students",
    },
  ]

  return (
    <div>
      <AdvancedTable
          columnDefinitions={columnDefinitions}
          enableToggleExpansion="all"
          fullWidthCell
          tableData={MOCK_DATA}
          {...props}
      >
        <AdvancedTable.Header enableSorting />
        <AdvancedTable.Body />
      </AdvancedTable>
    </div>
  )
}

export default AdvancedTableFullWidthCell
